import { getReCaptchaToken } from '../../js/get_recaptcha_token';

export async function verifyEmail(url: string, email: string) {
    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email: email }),
    });

    if (!res.ok) {
        throw new Error('Email verification failed');
    }
    const data = await res.json();

    return data;
};

export async function login(url: string, email: string, password: string, remember: boolean) {
    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest', // Required for Symfony to recognize the request as AJAX ($request->isXmlHttpRequest())
        },
        body: JSON.stringify({
            '_username': email,
            '_password': password,
            '_target_path': document.location.pathname,
            '_remember_me': remember,
        }),
    });

    if (!res.ok) {
        throw new Error('Login failed');
    }

    return await res.json();
};

export async function postReaction(url: string, user: object, reaction: object, new_password: string) {
    try {
        const token = await getReCaptchaToken('reaction_form');

        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'g-recaptcha-response': token,
                user, reaction, new_password
            })
        });

        return await res.json();
    } catch (error: any) {
        return {
            success: false,
            message: 'An unexpected error occurred',
        };
    }
};